// extracted by mini-css-extract-plugin
module.exports = {"root":"DestinationsBlock_root__SNkWr"};